import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NavSignalsService } from '@core/services/nav.signals.service';
import { environment } from '@environments/environment';
import { AppService } from 'app/app.service';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { filter, Subscription } from 'rxjs';
import { BadgeModule } from 'primeng/badge';
import { SignalsService } from '@shared/services/signals/signals.service';

@Component({
  selector: 'app-nav-menu',
  standalone: true,
  imports: [
    CommonModule,
    MenuModule,
    BadgeModule
  ],
  templateUrl: './nav-menu.component.html',
  styleUrl: './nav-menu.component.scss'
})
export class NavMenuComponent implements OnInit, OnDestroy {

  sidenavVisible = this.navSignalsService.sidenavVisible$;
  sidenavMaskVisible = this.navSignalsService.sidebarMaskVisible$;
  version: string = environment.appVersion;

  isAdminRole$?: boolean = false;
  sub!: Subscription;

  menuItems: MenuItem[] = [];

  constructor(
    public navSignalsService: NavSignalsService,
    private siginalService: SignalsService,
    public appService: AppService,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.sub = this.siginalService.isAdminRole$.subscribe({
      next: (isAdminRole) => {
        this.isAdminRole$ = isAdminRole;
        this.loadMenuItems();
      }
    })
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  loadMenuItems(): void {
    this.menuItems = [
      {
        id: '1',
        label: 'Flights',
        iconLight: '/assets/icons/aircraft/activeLight.svg',
        iconDark: "/assets/icons/aircraft/activeDark.svg",
        route: 'flights',
        visible: true,
        disabled: false,
        selected: false,
        command: () => {
          this.onMenuClick(this.menuItems[0]);
        }
      },
      {
        id: '2',
        label: 'Analyze',
        icon: "pi pi-history",
        route: 'analyze',
        visible: true,
        disabled: false,
        selected: false,
        command: () => {
          this.onMenuClick(this.menuItems[1]);
        }
      },
      {
        id: '3',
        label: 'Search',
        icon: 'pi pi-search',
        route: 'search',
        visible: true,
        disabled: false,
        selected: false,
        command: () => {
          this.onMenuClick(this.menuItems[2]);
        }
      },
      {
        id: '4',
        label: 'Export (Coming Soon)',
        icon: 'pi pi-file-export',
        route: 'export',
        visible: true,
        disabled: true,
        selected: false,
        command: () => {
          this.onMenuClick(this.menuItems[3]);
        }
      },
      {
        id: '5',
        label: 'Settings (Coming Soon)',
        icon: 'pi pi-cog',
        route: 'settings',
        visible: true,
        disabled: true,
        selected: false,
        command: () => {
          this.onMenuClick(this.menuItems[4]);
        }
      },
      {
        id: '6',
        label: 'About',
        icon: 'pi pi-info-circle',
        route: 'about',
        visible: true,
        disabled: false,
        selected: false,
        command: () => {
          this.onMenuClick(this.menuItems[5]);
        }
      },
      {
        id: '7',
        label: 'Admin',
        icon: 'pi pi-users',
        route: 'admin',
        disabled: !this.isAdminRole$, //User must have admin role to see this
        visible: this.isAdminRole$, //User must have admin role to see this
        selected: false,
        command: () => {
          this.onMenuClick(this.menuItems[6]);
        }
      }
    ];

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.updateSidebarSelection(event.urlAfterRedirects);
    });

    this.updateSidebarSelection(this.router.url);
  }

  onMenuClick(item: MenuItem) {
    this.menuItems.forEach((_, idx) => {
      let index = this.menuItems?.findIndex((items) => items === item);
      this.menuItems[idx].selected = false;
      this.menuItems[index].selected = true;
    });
    sessionStorage.removeItem('to');
    this.sidenavVisible.set(false);
    this.sidenavMaskVisible.set(false);
    this.navSignalsService.topBarTitle$.set(item.label || '');
  }

  updateSidebarSelection(url: string): void {
    this.menuItems.forEach(item => {
      if (url.includes(item.route)) {
        this.menuItems.forEach(item => item.selected = false);
        item.selected = url.includes(item.route);
        this.sidenavMaskVisible.set(false);
        this.navSignalsService.topBarTitle$.set(item.label || '');
      }
    });

  }
}
